import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/border.css'
import './styles/colors.css'
import './styles/fonts.css'
import './styles/gaps.css'
import {
  createAgent,
  MeshOutNotification,
  MessagingService,
  MessagingServiceProvider,
  ReauthNeededInfoSaver,
} from './agent'
import MeshSite from './ui/meshsite'
import { MeshAppBridge } from './meshAppBridge/bridge'
import { isLocalhost } from './environment'

const agent = createAgent()
const messagingService = new MessagingService(agent)
const meshAppBridge = new MeshAppBridge(agent)
const reauthInfoSaver = new ReauthNeededInfoSaver()

window.addEventListener('load', async () => {
  reauthInfoSaver.clearReauthNeededInfo()
  try {
    agent.setReauthenticationNeededListener(onReauthenticationNeeded)
    await agent.initialize()
    agent.addMeshOutNotificationListener(onMeshOut)
  } catch (err) {
    console.error('Error initializing agent:', err)
  }
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  )

  const isAuthenticated = agent.isAuthenticated()
  if (!isAuthenticated) {
    meshOut(true)
    return
  }

  console.log('Is localhost:', isLocalhost)
  if (isLocalhost) {
    console.log('Running in localhost mode')
    await fetchInitialDate()
  }

  checkMeshfaStatus()

  root.render(
    <React.StrictMode>
      <MessagingServiceProvider service={messagingService}>
        <MeshSite bridge={meshAppBridge} />
      </MessagingServiceProvider>
    </React.StrictMode>,
  )
})

window.addEventListener('message', async event => {
  if (event.data?.type === 'lookupSiteRequest') {
    console.log('Received lookup site request:', event.data)
    const port = event.ports[0]

    try {
      const siteName = event.data.siteName
      console.log('[Parent] Looking up site:', siteName)
      const response = await messagingService.lookupSite(siteName)
      meshAppBridge.setInitialData(response)
      const siteInfo = response?.payload
      console.log(
        '[Parent] Lookup site response:',
        response?.payload?.proxyLinkCode,
      )

      port.postMessage(siteInfo)
    } catch (err) {
      console.warn('[Parent] Could not get siteInfo:', err)
      port.postMessage({})
    }
  }
})

function meshOut(canReturn: boolean) {
  console.log('Mesh out. Can return:', canReturn)
  if (canReturn) {
    reauthInfoSaver.saveReauthNeededInfo()
  }
  window.location.href = '/'
}

function onMeshOut(_: MeshOutNotification) {
  meshOut(false)
}

function reauth(hasMeshfaClient?: boolean) {
  reauthInfoSaver.saveReauthNeededInfo(hasMeshfaClient)
  window.location.href = '/reauth'
}

async function fetchInitialDate() {
  ////////// Temporary code to get proxy link code and pass it to the bridge before checking MeshFA status
  const response = await messagingService.lookupSite(
    '/orgs/MKYMfV_Fde6XN9YNSM_GTNPWqQ8Pi5HhRBzkerhEARU/admin',
    // '/orgs/IJtA-nCLgZof50AojZ3pp_Dvt08aIrIVDzhZNKF1MxY/admin',
  )
  console.log(
    'Lookup site response in fetchInitialDate:',
    response.header.status,
  )
  const proxyLinkCode = response.payload?.proxyLinkCode
  console.log('Proxy link code from lookupSite:', proxyLinkCode)
  meshAppBridge.setInitialData(response)

  //////////
}

async function checkMeshfaStatus() {
  console.log('Checking MeshFA status...')

  const response = await messagingService.checkMeshfaStatus(true, false)
  if (response.header.status !== 0) {
    console.warn(
      'Check MeshFA status returned non-success status:',
      response.header.status,
      response.header.statusMessage,
    )
    return
  }

  const { meshfaDone, hasMeshfaClient } = response.payload ?? {}
  console.log('MeshFA Done:', meshfaDone)
  console.log('Has MeshFA Client:', hasMeshfaClient)
  if (meshfaDone) return
  reauth(hasMeshfaClient)
}

function onReauthenticationNeeded() {
  reauth()
}
